import React from 'react';
import { Container, Panel } from '@michelin/acid-components';
import { useTranslation } from '@michelin/central-provider';
import { PageTitle } from 'components/PageTitle/PageTitle';

export function MechanicalModule() {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle title={t('Mechanical Preferences')} />
      <Container>
        <Panel spacing={0}>
          <div>{t('Mechanical Preferences content coming soon')}</div>
        </Panel>
      </Container>
    </>
  );
}
